export const defaultModalStatus = {
  addDevice: {
    type: 'addDevice',
    status: false
  }
};